import React from "react";
import FilterChip from "./FilterChip";

const HISTORY_TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: "WELCOME", label: "Welcome" },
  { value: "VISIT", label: "Visit" },
  { value: "COMPLIMENT", label: "Compliment" },
  { value: "PROPOSAL", label: "Proposal" },
  { value: "PROMOTIONAL_MESSAGE", label: "Promotional Message" },
  { value: "ADMIN_SINGLE_USER_NOTIFICATION", label: "Single User" },
  { value: "ADMIN_FILTERED_NOTIFICATION", label: "All Filtered User" },
];

const inputClass =
  "w-full p-2.5 text-xs md:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700 min-w-0";

export default function HistoryFilters({
  filters,
  onFilterChange,
  getFilterLabel,
  onRemoveFilter,
  onClearAll,
  activeCount,
}) {
  return (
    <>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
        <h3 className="text-base md:text-xl font-bold text-gray-800">
          Notification History
        </h3>
        {activeCount > 0 && (
          <button
            type="button"
            onClick={onClearAll}
            className="text-sm text-red-600 hover:text-red-700 font-medium whitespace-nowrap">
            Clear All Filters
          </button>
        )}
      </div>

      {activeCount > 0 && (
        <div className="mb-4 flex flex-wrap gap-2 p-4 bg-gray-50 rounded-lg border border-gray-200 min-w-0">
          <span className="text-sm font-medium text-gray-700 self-center w-full sm:w-auto">
            Active Filters:
          </span>
          {filters.type && (
            <FilterChip
              label={`Type: ${getFilterLabel("type", filters.type)}`}
              onRemove={() => onRemoveFilter("type")}
              variant="red"
            />
          )}
          {filters.startDate && (
            <FilterChip
              label={`From: ${getFilterLabel("startDate", filters.startDate)}`}
              onRemove={() => onRemoveFilter("startDate")}
              variant="blue"
            />
          )}
          {filters.endDate && (
            <FilterChip
              label={`To: ${getFilterLabel("endDate", filters.endDate)}`}
              onRemove={() => onRemoveFilter("endDate")}
              variant="green"
            />
          )}
        </div>
      )}

      <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200 min-w-0">
        <div className="min-w-0">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Type
          </label>
          <select
            value={filters.type}
            onChange={(e) => onFilterChange("type", e.target.value)}
            className={inputClass}>
            {HISTORY_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value || "all"} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className="min-w-0">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Start Date
          </label>
          <input
            type="date"
            value={filters.startDate}
            onChange={(e) => onFilterChange("startDate", e.target.value)}
            className={inputClass}
          />
        </div>
        <div className="min-w-0">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            End Date
          </label>
          <input
            type="date"
            value={filters.endDate}
            onChange={(e) => onFilterChange("endDate", e.target.value)}
            className={inputClass}
          />
        </div>
      </div>
    </>
  );
}
